module.exports = __webpack_public_path__ + "static/course5-5c84d83d38982f110b080ef951c6f544.jpg";